import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlannerClassicRoute: InvariantJiraRoute = {
	name: 'software-planner-classic',
	path: '/jira/software/c/projects/:projectKey/planner',
	exact: true,
};
